/**
 * React mount + boot orchestration.
 *
 * Boot order:
 *   1. Mount AppShell with no AppContext (shows UnlockSurface).
 *   2. User generates or unlocks identity via the keyring SharedWorker.
 *   3. bootApp() wires storage/sync/transport/director.
 *   4. Register built-in surfaces.
 *   5. Director.bridge() into the hub.
 *
 * On keyring auto-lock the AppShell receives the lock event and tears the
 * UI back down to the UnlockSurface. State is dropped; the user re-unlocks
 * to resume.
 */

import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppShell } from './ui/AppShell';
import { ShellProvider } from './ui/shells/ShellProvider';
import './ui/global.css';

const root = createRoot(document.getElementById('root')!);
root.render(
  <ShellProvider>
    <AppShell />
  </ShellProvider>,
);
